import styled from "styled-components";

export const Wrapper = styled("div")(({ theme }) => ({
  ...theme.mixins.flexColumn,
}));

export const Header = styled("div")(({ theme }) => ({
  padding: '0 24px 24px 24px',
  borderBottom: `1px solid ${theme.palette.borderLight}`,

  [theme.down("sm")]: {
    padding: '0 15px 15px 15px',
  },
}));

export const Title = styled("h2")(({ theme }) => ({
  fontSize: '18px',
  fontWeight: '600',
  color: theme.palette.textPrimary,
  marginBottom: '5px',

  [theme.down("sm")]: {
    fontSize: '16px',
  },
}));

export const Description = styled("div")(({ theme }) => ({
  fontSize: 14,
  color: theme.palette.textMuted,
  marginBottom: 10,

  [theme.down("sm")]: {
    fontSize: 13,
  },
}));

export const FormBlock = styled("div")(({ theme }) => ({
  display: "grid",
  gap: 16,
  padding: '24px',
  
  "&.two-col": {
    gridTemplateColumns: "repeat(2, 1fr)",
    [theme.down("md")]: {
      gridTemplateColumns: "1fr",
    },
  },

  "&.three-col": {
    gridTemplateColumns: "repeat(3, 1fr)",
    [theme.down("md")]: {
      gridTemplateColumns: "1fr",
    },
  },

  [theme.down("sm")]: {
    padding: '15px',
    gap: 12,
  },
}));

export const InputBlock = styled("div")(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
}));
